import React from "react";
import "./New.scss";
import Comingsoon from "../../../Media/Web_Wander Alley.webp";
import Soon from "../../../Media/Mobile_Wander Alley.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6282122005507&text=Halo%20Dean,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20BSD%20City%20(Wander%20Alley)%20https://bsdcity-marketing.id//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="vireya" className="container-soon">
      <div className="louise">
        <h1>New Launching Ruko Commercial BSD City</h1>
        <h1>Wander Alley</h1>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
